import { Link } from "react-router-dom";
import { STUDIO } from "../lib/studio.ts";
import "./site-chrome.css";

/**
 * The crest, the sections, the small print.
 *
 * The section links are router links to "/#section" rather than bare anchors,
 * because the footer is on every page: from /book they have to go home first,
 * and the ScrollManager in App takes it from there.
 */
export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="page site-footer__inner">
        <Link
          to="/"
          className="site-footer__crest"
          aria-label="The Renewal Studio, home"
        >
          <img src="/images/logo.webp" alt="" width={96} height={95} loading="lazy" />
        </Link>

        <nav className="site-footer__nav" aria-label="Footer">
          <Link to="/#treatments">Treatments</Link>
          <Link to="/#studio">The Studio</Link>
          <Link to="/#about">About Lou</Link>
          <Link to="/#visit">Visit</Link>
          <a
            href={`https://instagram.com/${STUDIO.instagram}`}
            target="_blank"
            rel="noreferrer noopener"
          >
            Instagram
          </a>
          <Link to="/admin">Studio login</Link>
        </nav>

        <p className="site-footer__legal">
          &copy; {new Date().getFullYear()} {STUDIO.name}
          <span aria-hidden="true"> · </span>
          {STUDIO.addressLines[0]}
        </p>
      </div>
    </footer>
  );
}
